module.exports = __webpack_public_path__ + "img/tu07.1533ddc7.png";